import { computed, type Ref } from 'vue'
import scssVariables from '@/assets/scss/scssVariables'

import {
  STATUS_RESOURCE_REQUEST_FEEDBACK,
  type StatusResourceRequestFeedback,
  STATUS_RESOURCE_REQUEST_FEEDBACK_LOOKUP_LABEL,
} from '@/constants/persoplan'

import { lookup } from '@/utilities/misc'
import { isNil } from 'lodash-es'

export { type StatusResourceRequestFeedback, STATUS_RESOURCE_REQUEST_FEEDBACK }

interface Options {
  status: Ref<StatusResourceRequestFeedback | undefined | null>
}

const colors = {
  unknown: scssVariables.color['status-resourceRequest-notAnswered'],
  accept: scssVariables.color['status-resourceRequest-accept'],
  maybe: scssVariables.color['status-resourceRequest-maybe'],
  decline: scssVariables.color['status-resourceRequest-decline'],
} as const satisfies Partial<Record<StatusResourceRequestFeedback, string>>

export function useResourceRequestFeedbackStatus(options: Options) {
  const statusNormalized = computed(() => {
    if (isNil(options.status.value))
      return STATUS_RESOURCE_REQUEST_FEEDBACK.unknown

    return options.status.value
  })

  const classes = computed(() => {
    return {
      [`is-statusResourceRequestFeedback-${statusNormalized.value}`]: true,
    }
  })

  const color = computed(() => {
    return colors[statusNormalized.value]
  })

  const label = computed(() => {
    return lookup(
      statusNormalized.value,
      STATUS_RESOURCE_REQUEST_FEEDBACK_LOOKUP_LABEL
    )
  })

  return {
    classes,
    color,
    label,
  }
}
